// extracted by mini-css-extract-plugin
export default {"support":"Support_support__9J-Ya","supportPhone":"Support_supportPhone__Je5ka"};